// client/src/pages/ownerListings/OwnerVerifyEmailPage.js — the link in the confirmation email.
import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

const OwnerVerifyEmailPage = () => {
    const [sp] = useSearchParams();
    const [state, setState] = useState({ busy: true, ok: false, msg: '' });
    useEffect(() => {
        fetch('/api/owner-listings/verify-email', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token: sp.get('token') || '' }) })
            .then(async (r) => { const j = await r.json().catch(() => ({})); setState({ busy: false, ok: r.ok, msg: j.message || (r.ok ? 'Confirmed.' : 'This link did not work.') }); })
            .catch(() => setState({ busy: false, ok: false, msg: 'This link did not work. Please try again.' }));
    }, [sp]);
    return (
        <div className="flex min-h-screen items-center justify-center bg-slate-100 p-4">
            <main className="w-full max-w-md rounded-lg bg-white p-8 text-center shadow">
                <h1 className="text-2xl font-bold text-slate-900">Confirm your email</h1>
                <p className={`mt-4 ${state.ok ? 'text-emerald-800' : 'text-slate-800'}`} role="status">{state.busy ? 'Checking…' : state.msg}</p>
                {!state.busy && <p className="mt-6"><Link to="/client-portal/my-listings" className="font-semibold text-indigo-800 underline">Go to My Listings</Link></p>}
            </main>
        </div>
    );
};
export default OwnerVerifyEmailPage;
